export const languages = [
  {
    value: 'zh-hant',
    label: '繁體中文',
    i18n: 'zh-TW',
  },
  {
    value: 'en',
    label: 'English',
    i18n: 'en-us',
  },
]

export const getI18nLocale = (lang) => {
  return languages.find((item) => item.value === lang)?.i18n ?? 'zh-TW'
}

export const userLocale = JSON.parse(localStorage.getItem('user'))?.language || 'zh-hant'
